import React from 'react';
import MainCarousel from '../components/Carousel/MainCarousel';
import ProductList from './ProductList';
import useGetBeatInfo from '../hooks/useGetBeatInfo';
import { useRecoilValue } from 'recoil';
import { countryState } from '../recoil/country/countryAtom';

const Home = () => {
  const accessToken = localStorage.getItem('access_token');
  const countryData = useRecoilValue(countryState);

  const { isLogin } = useGetBeatInfo(accessToken, countryData?.country);

  return (
    <div>
      <div>
        <MainCarousel isLogin={isLogin} />
      </div>
      <div>
        <ProductList isLogin={isLogin} />
      </div>
    </div>
  );
};

export default Home;
